module.exports = __webpack_public_path__ + "static/devonyuresume-d602d39cbf065c92d67d5a29bdbb907f.pdf";